import type { JSX } from 'react'

import { SimpleRowSkeletonItem } from './RowSkeleton.styled'

export interface ISimpleRowSkeletonItemsProps {
  visibleCards: number
}

export const SimpleRowSkeletonItems = ({
  visibleCards,
}: ISimpleRowSkeletonItemsProps): JSX.Element => {
  return (
    <>
      {Array.from({ length: visibleCards + 1 }, (_, index) => (
        <SimpleRowSkeletonItem key={`${visibleCards}_${index}`} />
      ))}
    </>
  )
}
